/**
 * Risky sign-in check (server: verification_connexion).
 *
 * After a risky web sign-in, the server returns tokens carrying a `verif`
 * claim: the whole API answers 403 `verification_required` until the code is
 * confirmed on the /verification screen. The browser keeps a random secret
 * (never sent anywhere else) so the server can remember it for 30 days when
 * the person ticks "Remember this browser"; the server only stores its hash.
 */

const DEVICE_KEY = 'callizy_appareil'
export const DEVICE_HEADER = 'X-Callizy-Appareil'

export type Canal = 'sms' | 'call' | 'email'

export interface VerificationState {
  requise: boolean
  canal: Canal
  canaux: Canal[]
  telephone_fin: string
  courriel_masque: string
  envoye?: boolean
  erreur?: string
}

function randomSecret(): string {
  const bytes = new Uint8Array(32)
  crypto.getRandomValues(bytes)
  return btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

/** The browser secret, created on first use. Kept across sign-outs (see LOGOUT_PRESERVED_KEYS). */
export function deviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_KEY)
    if (existing && /^[A-Za-z0-9_-]{32,128}$/.test(existing)) return existing
    const created = randomSecret()
    localStorage.setItem(DEVICE_KEY, created)
    return created
  } catch {
    // Private mode or blocked storage: the browser is simply never remembered.
    return ''
  }
}

export function deviceHeaders(): Record<string, string> {
  const id = deviceId()
  return id ? { [DEVICE_HEADER]: id } : {}
}

/** True when the access token still waits for its sign-in code. */
export function tokenNeedsVerification(token: string | null | undefined): boolean {
  if (!token) return false
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
    return Boolean(payload.verif)
  } catch {
    return false
  }
}
